<div class="d-flex flex-column w-100">
  <div class="section-title-3-border bg-{{color}}"></div>
  <h5 class="elsa-title-font text-{{color}} text-uppercase section-title-3-title">{{title}}</h5>
</div>
